'use strict';

module.exports = function () {
    $('.ckc-button').on('click', function () {
        $(this).blur();
    });
};
